export const chatbotModules = {
  // Login Module
  login: {
    name: "Login Assistant",
    greeting: "Welcome! I'm here to help you access your account securely. How can I assist you today?",
    recommendedOptions: [
      "Login to my account",
      "Reset my password",
      "Create new account",
      "Get help with login issues",
      "View system requirements",
      "Contact support"
    ],
    workflows: {
      // All workflows handled by LoginChatbot.jsx
    },
    defaultResponse: (message) => {
      const suggestions = [
        ":closed_lock_with_key: Type 'login' to access your account",
        ":key: Type 'forgot password' to reset your password",
        ":memo: Type 'sign up' to create a new account",
        ":question: Type 'help' for assistance and support",
        ":information_source: Type 'system info' for technical requirements"
      ];
      return `I'm not sure how to help with "${message}" for login assistance.\n\n` +
       `Here are some things I can help you with:\n\n` +
       suggestions.join('\n') + '\n\n' +
       `Just type your request naturally, and I'll guide you through the process!`;
    }
  },
  // Apartment Management Module
  apartment: {
    name: "Apartment Assistant",
    greeting: "Hello! I'm your apartment management assistant. How can I help you today?",
    recommendedOptions: [
      "Add blocks to my apartment",
      "Show all apartments",
      "Manage parking",
      "Access resident information"
    ],
    workflows: {
      addBlocks: {
        startCommand: /add block/i,
        responses: {
          start: "Great! Please provide the block names one at a time. Type each name and press enter. When you're done, type 'done' to continue.",
          confirmation: (blocks) => `Are you sure you want to add these blocks to your apartment?\n- ${blocks.join('\n- ')}\n\nType "Yes Add" to confirm or "No" to cancel.`,
          added: (count) => `Success! Added ${count} new block${count !== 1 ? 's' : ''} to your apartment.`,
        }
      }
    },
    defaultResponse: (message) => `I'm not sure how to help with "${message}" in apartment management. Would you like to add blocks, manage residents, or check parking information?`
  },
  // Dashboard Module
  dashboard: {
    name: "Society Assistant",
    greeting: "Welcome to your dashboard! I can help you navigate and understand your analytics. How may I assist you?",
    recommendedOptions: [
      "Show monthly statistics",
      "Generate performance report",
      "Update dashboard widgets",
      "Set up alerts"
    ],
    workflows: {
      statistics: {
        startCommand: /statistics|report|analytics/i,
        responses: {
          start: "I can help you with statistics. What specific period are you interested in? (This month, Last quarter, Year to date)",
        }
      }
    },
    defaultResponse: (message) => `I'm not sure how to help with "${message}" on the dashboard. Would you like to view statistics, generate reports, or manage widgets?`
  },
  // Simplified Maintenance Payment Module
  maintenancepayment: {
    name: "Maintenance Payment Assistant",
    greeting: "Hello! I'm your maintenance payment assistant. I can help you manage payments, track dues, send reminders, and view analytics. How can I assist you today?",
    recommendedOptions: [
      "Check payment status for a flat",
      "Process payment for resident",
      "Send payment reminders",
      "View collection analytics",
      "Handle partial payments",
      "Apply late fees or discounts",
      "Generate payment reports",
      "Search overdue payments"
    ],
    // All workflows and complex logic moved to MaintenancePaymentChatbot.jsx
    defaultResponse: (message) => {
      const suggestions = [
        ":credit_card: Type 'check payment A-101' to check a flat's payment status",
        ":moneybag: Type 'process payment' to record a new payment",
        ":e-mail: Type 'send reminder' to notify residents about dues",
        ":bar_chart: Type 'show analytics' to view collection statistics",
        ":siren: Type 'overdue payments' to see pending dues",
        ":page_facing_up: Type 'generate report' to create payment reports"
      ];
      return `I'm not sure how to help with "${message}" in maintenance payment management.\n\n` +
             `Here are some things I can help you with:\n\n` +
             suggestions.join('\n') + '\n\n' +
             `Just type your request naturally, and I'll assist you!`;
    }
  },
  // Default fallback module (when no specific route is matched)
  default: {
    name: "Society Assistant",
    greeting: "Hello! I'm your administrative assistant. How can I help you today?",
    recommendedOptions: [
      "Navigate to a section",
      "Search for information",
      "Update your profile",
      "Get help with the system"
    ],
    workflows: {},
    defaultResponse: (message) => `I'm not sure how to help with "${message}". Would you like me to help you navigate to a specific section?`
  }
};
